import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {filterParams} from '../application/Api'
import {IListFilters} from '../shared/SearchFilterBar'
import {ITrackingModel, ITrackingUpdateRequest} from './TrackingModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const TRACKING_URL = `${API_URL}api/v1/candidate-tracking/`

export function searchTrackings(
  filters: Partial<IListFilters>,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<ITrackingModel>>>> {
  return corporateApi.get(`${TRACKING_URL}search`, {
    params: {...filterParams(filters), page, size, sort: 'updatedDate,desc'},
  })
}

export function getTracking(id: string): Promise<AxiosResponse<ApiResponse<ITrackingModel>>> {
  return corporateApi.get(`${TRACKING_URL}getById/${id}`)
}

export function updateTracking(
  id: string,
  request: ITrackingUpdateRequest
): Promise<AxiosResponse<ApiResponse<ITrackingModel>>> {
  return corporateApi.patch(`${TRACKING_URL}update/${id}`, request)
}

/** Dallanmada nextStepId ile hangi adıma geçileceği seçilir */
export function advanceTracking(
  id: string,
  nextStepId?: string
): Promise<AxiosResponse<ApiResponse<ITrackingModel>>> {
  return corporateApi.post(`${TRACKING_URL}advance/${id}`, null, {params: nextStepId ? {nextStepId} : {}})
}

export function backTracking(id: string): Promise<AxiosResponse<ApiResponse<ITrackingModel>>> {
  return corporateApi.post(`${TRACKING_URL}back/${id}`)
}

export function deleteTracking(id: string) {
  return corporateApi.delete(`${TRACKING_URL}delete/${id}`)
}
